"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NEXT_AVAILABILITY = void 0;
const NEXT_AVAILABILITY = exports.NEXT_AVAILABILITY = 'next-availability';
//# sourceMappingURL=constants.js.map